import React from 'react';

const ALLOWED_FORMATS = ['png', 'jpeg', 'jpg', 'gif', 'webp', 'svg+xml'];
const BASE64_RE = /^[A-Za-z0-9+/]*={0,2}$/;
const MAX_BASE64_LENGTH = 7_000_000; // ~5MB decoded

function ImageFromBase64({ base64Data, format, style }) {
  const isValid =
    typeof format === 'string' &&
    ALLOWED_FORMATS.includes(format.toLowerCase()) &&
    typeof base64Data === 'string' &&
    base64Data.length > 0 &&
    base64Data.length <= MAX_BASE64_LENGTH &&
    BASE64_RE.test(base64Data);

  if (!isValid) return null;

  const dataURI = `data:image/${format};base64,${base64Data}`;

  return <img style={style} src={dataURI} alt="Decoded from base64" />;
}

export default ImageFromBase64;